// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"NestedMenu_buttonContainer__2XK0KL4PyBinqvgelbpIxQ","text":"NestedMenu_text__2U3P6bx3VZFTCrDVrP44Pu"};